export const CHINA_COUNTRY_ISO = 'CN'
